import { Component, ErrorInfo, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route error:", error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-icon" aria-hidden="true">
            !
          </div>
          <h2>Something went wrong</h2>
          <p>{this.state.error.message || "An unexpected error occurred."}</p>
          <div className="error-boundary-actions">
            <button
              type="button"
              className="error-boundary-btn"
              onClick={this.reset}
            >
              Try again
            </button>
            <button
              type="button"
              className="error-boundary-btn error-boundary-btn--ghost"
              onClick={() => window.location.assign("/search")}
            >
              Back to search
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
